module.exports = __webpack_public_path__ + "static/media/ic_suspend.248c14f6.svg";